import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import Collapsemirrorsales from '../collapsemirrorsales/collapsemirrorsales.vue'
import priceunityenterpriseRepository from '@/shared/http/repositories/realestate/priceunityenterprise'
import EnterpriseUnityRepository from '@/shared/http/repositories/realestate/enterpriseunity'
import { toast, loading } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import documentsmanagement from '@/shared/http/repositories/realestate/documentsmanagement'
import Boardmediaenterprise from '@/views/private/realestate/enterprise/components/boardmediaenterprise/boardmediaenterprise.js'
import TableDocuments from '@/views/private/documentsManagement/components/TableDocuments/TableDocuments.vue'
import FileEnterpriseRepository from '@/shared/http/repositories/realestate/fileenterprise'

export default {
  name: 'Mirrorsalesenterprise',
  props: ['dataEnterprise', 'title'],
  mixins: [ActionsForm],
  components: {HeadDetailsGama, Collapsemirrorsales, Boardmediaenterprise, priceunityenterpriseRepository, TableDocuments},
  data () {
    return {
      headTable: ['DOCUMENTO', 'DESCRIÇÃO', ''],
      dataFiles: [],
      keyTablepricedocument: 0,
      nameInput: '',
      dataPdf: [],
      dataTable: [],
      dataParcela: [],
      descricaoConteudo: null,
      dataUnidade: [],
      op: [
        {
          title: 'Opção 1',
          head: ['A VISTA 5% DE DESCONTO']
        },
        {
          title: 'Opção 2',
          head: ['12 PARCELAS FIXAS']
        },
        {
          title: 'Opção 3',
          head: ['ENTRADA 10% EM 6 PARCELAS FOXAS', '10% NA ENTREGA CORRIGIDO PELO INCC']
        }
      ]
    }
  },
  mounted () {
    // this.GetAllOptions()
    // this.getAllUnityByEntreprise()
    this.GetPdf()
  },
  methods: {
    GetValueFile (e) {
      this.nameInput = e.target.files[0].name
    },
    showmodal () {
      this.$refs.images.show()
      document.querySelector('#impor-pdf').value = ''
    },
    cancelImage () {
      this.$refs.images.hide()
      document.querySelector('#impor-pdf').value = ''
      this.nameInput = ''
      this.descricaoConteudo = null
    },
    GetAllOptions () {
      loading.push()
      priceunityenterpriseRepository.GetAllOptions()
        .then(Response => {
          this.dataParcela = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getAllUnityByEntreprise () {
      loading.push()
      EnterpriseUnityRepository.GetAllWithPrecoByEmpreendimentoId(this.dataEnterprise.id)
        .then(Response => {
          this.dataUnidade = Response.data.data
          this.GetAllOptionsByEnterpriseId()
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    GetAllOptionsByEnterpriseId () {
      priceunityenterpriseRepository.GetAllOptionsByEnterpriseId(this.dataEnterprise.id)
        .then((Response) => {
          this.dataParcela = Response.data
        })
        .catch((Error) => {

        })
    },
    getDataTable (parcela) {
      if (this.dataUnidade == null) return null
      if (this.dataUnidade.length === 0) return null
      return this.dataUnidade.filter((Element) => Element.reEmpreendimentoUnidadePrecoo.nome === parcela.nome)
    },
    openFile () {
      document.getElementById('impor-ex').click()
    },
    openFilePdf () {
      document.getElementById('impor-pdf').click()
    },
    imporTable (e) {
      if (e.target.files.length === 0) return
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let data = new FormData()
      data.append('Excel', e.target.files[0])
      loading.push()
      priceunityenterpriseRepository.ImportableByEmpreendimento(this.dataEnterprise.id, data, conf)
        .then(Response => {
          this.GetAllOptions()
          // this.getAllUnityByEntreprise()
          toast.success('Excel importado com sucesso!!', 'Excel')
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toast.error('Formato invalido!!', 'Excel')
        })
    },

    imporTablePdf (e) {
      e = document.querySelector('#impor-pdf')
      if (this.descricaoConteudo !== null) {
        loading.push()
        let obj = {
          data: e.files[0]
        }
        let conf = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        let pdf = new FormData()
        pdf.append('pdf', obj.data)
        pdf.append('descricaoconteudo', this.descricaoConteudo)
        priceunityenterpriseRepository.SaveTabelaPdf(this.dataEnterprise.id, pdf, conf)
          .then(Response => {
            this.GetPdf()
            let input = document.querySelector('#impor-pdf')
            if (input !== undefined) input.value = ''
            // this.$refs.images.hide()
            this.nameInput = ''
            this.descricaoConteudo = null
            toast.success(`Documento PDF adicionado com sucesso`)
            loading.pop()
            this.closeUploadPopup()
          })
          .catch(err => {
            toast.error(err.response.data)
            loading.pop()
          })
      } else {
        toast.warning('Campo de Descrição do Conteúdo deve ser preenchido!')
      }
    },

    modalImg (e) {
      // Get the modal
      this.$refs.images.hide()
      var modal = document.getElementById('myModal')
      // Get the image and insert it inside the modal - use its "alt" text as a caption
      var img = e.target
      var modalImg = document.getElementById('img01')
      var captionText = document.getElementById('caption')
      modal.style.display = 'block'
      modalImg.src = img.src
      captionText.innerHTML = img.alt
      // Get the <span> element that closes the modal
      var span = document.querySelector('.close')

      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        modal.style.display = 'none'
      }
    },
    imageDetails (obj) {
      this.imgDetails = obj
      this.$refs.modalPdfImagemSelector.show()
    },
    openunitytypeselector (id) {
      this.$refs.openunitytype.tipoId = id
      this.$refs.openunitytype.show(id)
    },

    GetPdf () {
      loading.push()
      priceunityenterpriseRepository.GetPdf(this.dataEnterprise.id)
        .then(Response => {
          this.dataPdf = []
          this.dataPdf = Response.data.data
          this.$refs.tableDocuments.LoadAllByData(Response)
          loading.pop()
          // this.isPdf = Response.dataEnterprise.descricao.includes('.pdf')
          // loading.pop()
        })
        .catch(Error => loading.pop())
    },
    RemovePdf () {
      priceunityenterpriseRepository.RemovePdf(this.dataEnterprise.id)
        .then(res => {
          this.GetPdf()
          document.querySelector('#impor-pdf').value = ''
          this.nameInput = ''
          if (res.status === 200) {
            toast.success(`Removido com sucesso`)
            loading.pop()
          }
        })
        .catch(() => {
          toast.error(`Erro ao remover`)
          loading.pop()
        })
    },
    openUploadPopup () {
      this.$refs['addtablepricemodal'].show()
      this.nameInput = ''
      this.descricaoConteudo = null
    },
    closeUploadPopup () {
      this.$refs['addtablepricemodal'].hide()
      this.nameInput = ''
      this.descricaoConteudo = null
    },

    openAddModal (obj) {
      this.comunicadoInfo = obj
      this.$refs['add-comunicado'].EditOpenAddModal(obj)
    },
    uploadNewDocument () {
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      if (this.file.length === 0) {
        this.displayWarning('Selecione um arquivo antes de enviar')
        return
      }
      let data = new FormData()
      data.append('arquivo', this.file)

      if (this.opDestiny === '1') {
        data.append('empreendimentoId', this.enterpriseSelected)
      }

      if (this.opDestiny === '2') {
        if (!this.customerSelected.find) {
          this.displayWarning('Por favor, selecione um cliente.')
          return
        }
        data.append('clienteId', this.customerSelected.id)
      }
      documentsmanagement.UploadDocumento(data, conf)
        .then(res => {
          if (res.status === 200) {
            if (res.data.data != null) {
              this.closeUploadPopup()
              this.file = []
              this.customerCpf = ''
              this.enterpriseSelected = ''
              this.customerSelected = {}
              this.$emit('updateTableDocuments')
              toast.success('Documento enviado com sucesso')
              loading.close()
            }
          }
        })
        .catch(() => {
          toast.error('Erro ao enviar documento')
          loading.close()
        })
    },
    onDownloadDocument (EnterpriseId) {
      priceunityenterpriseRepository.DownloadPdfbyId(EnterpriseId)
        .then(res => {
          if (res.status === 200) {
            console.log()
            let dataResponse = res.data.data
            const linkDownload = document.createElement('a')
            linkDownload.href = `data:image/png;base64,${dataResponse.arquivo.arquivo}`
            linkDownload.download = `${dataResponse.arquivo.descricao}.${dataResponse.arquivo.extensao}`
            linkDownload.click()
            URL.revokeObjectURL(linkDownload.href)
          }
        })
        .catch(err => console.log(err))
    },
    Delete (empreendimentoArquivoId) {
      FileEnterpriseRepository.ChangePdfStatus(empreendimentoArquivoId)
        .then(Response => {
          if (Response.status === 200) {
            this.dataPdf = Response.data.data
            toast.success(`Documento removido com sucesso`)
            this.GetPdf()
          }
        })
        .catch(() => {})
    },
    updateTableDocuments () {
      this.keyTablepricedocument++
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/mirrorsalesenterprise/mirrorsalesenterprise.js